import {
  ContractDeclarationGame,
  contractDeclarationGameNull,
} from '../models/contract-declaration-game'
import { GamePlayConfig, QueryResponse } from 'shared-services'
import { GamePlayGameId } from '../models/game-play-game-id'
import { ContractDeclarationGameDto } from '../dtos/contract-declaration-game.dto'
import { GetGameErrorCode } from '../error-codes/get-game.error-code'
import { contractDeclarationGameMapper } from '../mappers/contract-declaration-game.mapper'
import { Contract } from '../models/contract'
import { Card } from '../models/card'

export class ContractDeclarationService {
  public constructor(private readonly gamePlayConfig: GamePlayConfig) {}

  public async getContractDeclarationGame(
    gamePlayGameId: GamePlayGameId,
  ): Promise<QueryResponse<ContractDeclarationGame, GetGameErrorCode>> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId
    const query = `gamePlayId=${gamePlayId}&gameId=${gameId}`

    const response = await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/contract-declaration/v1/contract-declaration-game?${query}`,
      {
        credentials: 'include',
      },
    )

    const contractDeclarationGameResponse =
      (await response.json()) as QueryResponse<
        ContractDeclarationGameDto,
        GetGameErrorCode
      >

    const result = contractDeclarationGameResponse.isSuccessful
      ? contractDeclarationGameMapper.mapToContractDeclarationGame(
          contractDeclarationGameResponse.result,
        )
      : contractDeclarationGameNull

    return {
      errorCode: contractDeclarationGameResponse.errorCode,
      errorCodes: contractDeclarationGameResponse.errorCodes,
      isSuccessful: contractDeclarationGameResponse.isSuccessful,
      result,
    }
  }

  public async declareContract(
    gamePlayGameId: GamePlayGameId,
    contract: Contract,
    discardedCards: Card[],
  ): Promise<void> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId

    const body = {
      gamePlayId,
      gameId,
      contract: contract.contractType,
      discardedCards,
    }

    await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/contract-declaration/v1/declare-contract`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  }

  public async declareHandContract(
    gamePlayGameId: GamePlayGameId,
    contract: Contract,
  ): Promise<void> {
    const gamePlayId = gamePlayGameId.gamePlayId
    const gameId = gamePlayGameId.gameId

    const body = {
      gamePlayId,
      gameId,
      contract: contract.contractType,
    }

    await fetch(
      `${this.gamePlayConfig.apiBaseUrl}/contract-declaration/v1/declare-hand-contract`,
      {
        method: 'POST',
        body: JSON.stringify(body),
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )
  }
}
